export default __webpack_public_path__ + "static/media/circle-checked.b042bf8e.svg";